import { Box, Flex, Stack } from '@chakra-ui/react';
import { Property } from '@data/models';
import BEMap from '@molecules/BEMap';
import Text from '@molecules/Text';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const AddressAndContact = ({ model }: { model: Property }) => {
  const { t } = useTranslation();

  const city = useMemo(() => model?.address.city || '', [model]);
  const zip = useMemo(() => model?.address.zip || '', [model]);
  const email = useMemo(() => model?.contact.email || '', [model]);
  const phone = useMemo(() => model?.contact.phone || '', [model]);

  const contactName = useMemo(() => {
    if (!model) return '';
    const parts: string[] = [];
    if (model.contact.firstName) parts.push(model.contact.firstName);
    if (model.contact.lastName) parts.push(model.contact.lastName);
    return parts.join(' ');
  }, [model]);

  const address = useMemo(() => {
    if (!model) return '';
    const parts: string[] = [];
    if (model.address.address1) parts.push(model.address.address1);
    if (model.address.address2) parts.push(model.address.address2);
    return parts.join(' - ');
  }, [model]);

  const stateAndCountry = useMemo(() => {
    if (!model) return '';
    return (
      (model.address.state ? model.address.state + ' ' : '') +
      model.address.country
    ).trim();
  }, [model]);

  return (
    <Flex gap="16px">
      <Stack minW="40%">
        <Text type="h2" mb="8px">
          {t('address-and-contact')}
        </Text>
        {address && <Text>{address}</Text>}
        {city && <Text>{city}</Text>}
        {stateAndCountry && <Text>{stateAndCountry}</Text>}
        {zip && <Text>{zip}</Text>}
        {contactName && <Text>{contactName}</Text>}
        {phone && <Text>{phone}</Text>}
        {email && <Text>{email}</Text>}
      </Stack>
      {model?.settings.showMap && <BEMap {...model} />}
    </Flex>
  );
};

export default AddressAndContact;
